module.exports = __webpack_public_path__ + "static/img/ability-icon1.9c2cdab.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/ability-icon1.png
// module id = LMVk
// module chunks = 1